goog.provide('el8.app.setup');

goog.require('el8.app.onboarding.statusHeadline');
goog.require('el8.app.pageLayout');
goog.require('el8.app.service.UILayout');
goog.require('el8.app.shared.dialog.dataExchange');
goog.require('el8.app.shared.userHeadlines');
goog.require('el8.appchart.permissions');
goog.require('el8.appservice.status');
goog.require('el8.appservice.tabControl');
goog.require('el8.data.init');
goog.require('el8.service.tz');
goog.require('el8.service.urls');
goog.require('el8.uiwidget.alert');
goog.require('el8.util.consts');


/**
 * Some shared initialization for most app pages (chart, home, billing, etc.).
 * The major routines are commented on below.
 */
el8.app.setup = function(spec) {

    spec = spec || {};

    /**
     * Very first thing to do - initialize app-specific callback for processing ajax responses
     */
    var logout = function() {
        el8.appservice.status.forwardToLogin(false); // false = not a logout from inactivity
    };
    $.el8_ajaxOpts['processResponseFn'] = function(xhr, textStatus, data, err, msg, requestInfo) {

        var default_msg = el8.util.consts.DEFAULT_ERROR_MSG;

        // Get the Response Code
        if (xhr) {

            var msgFromResponse = null;
            // ok this is one of the more unfortunate things that I've come across.
            // Originally, we used to only care about err being truthy, but it turns out
            // that depending on the environment like local vs ellie, we would either
            // use HTTP/1.1 or HTTP/2, respectively. When it's HTTP/1.1, err would
            // actually have the text version of the status code (e.g. 400 -> "Bad
            // Request"), but HTTP/2 will have it as empty string. Since I think the
            // intention is to see if it's a 4XX or 5XX, we will instead check that.
            // See the error section of https://api.jquery.com/jquery.ajax/ for details.
            if (xhr.status >= 400) {
                // Figure out the correct error message
                try {
                    var responseData = JSON.parse(xhr.responseText);
                } catch(e) {
                }

                msgFromResponse = responseData && responseData.errors && responseData.errors[0] && responseData.errors[0].message;
            }

            var error_msg = msg || msgFromResponse || default_msg;

            switch(xhr.status) {

                /** Good news **/
                case 200: // Great!
                    el8.appservice.status.hideNoInternet();
                    break;

                /** Bad news **/
                case 409: // Conflict
                    el8.uiwidget.alert(el8.util.consts.DEFAULT_CONFLICT_ERROR_MSG);
                    break;
                case 404: // Page not found
                case 400: // Bad request; server couldn't understand
                case 403: // Forbidden; no permission
                case 500: // Internal server error
                case 504: // ELB timeout
                    if (jQuery.isFunction(error_msg)) {
                        el8.uiwidget.alert(error_msg(xhr.status, default_msg));
                    } else {
                        el8.uiwidget.alert(error_msg);
                    }
                    break;

                /** Server status issues **/
                case 421: // User not logged in
                    logout();
                    break;
                case 410: // Resource gone
                    // right now we just depend on the caller to treat an empty/null as a deletion
                    break;
                default: // Assume this is an internet issue
                    break;
            }
        }
    };
    $.el8_ajaxOpts['logoutFn'] = logout;

    /**
     * Initialize the global URL service
     */
    if (spec.urls) { el8.service.urls.init(spec.urls); }

    /**
     * The generic handle on controlling whole page layout
     */
    $.extend(spec.layout);
    el8.app.pageLayout.setup(spec.layout);

    /**
     * Initialize any data sent down with the page
     */
    if (spec.data) { el8.data.init(spec.data); }

    /**
     * Show statusHeadline on top of app
     */
    var showStatusHeadLine = spec.showStatusHeadLine !== false ;
    if (showStatusHeadLine && !el8.appchart.permissions.isUser('Patient') && !el8Globals.TEASE) {
        el8.app.onboarding.statusHeadline.display();
        el8.app.shared.userHeadlines.enable();
    }

    /**
     * Initialize the /status/ poller, which needs to be done after
     * the headlines are enabled so that the headlines show up on
     * the first status check (which sends down any headlines that
     * need to be displayed.
     */
    var initStatusService = (spec.init_status !== false);
    if(initStatusService ){
        el8.appservice.status.init();
    }
    /**
     * Successfully loading and running this setup() is an indicator
     * that a user is logged in. So, send a 'restoreTab' message to all
     * pages that *may* be listening for them. Pages that are not actively
     * listening will just ignore any messages.
     */
    el8.appservice.tabControl.issueRestoreTabMessage();
};
